/**
 * @flow
 * @relayHash dc4cf270861ab7d613e4b09b1b901d6f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeliverableState = "A_1" | "A_2" | "A_3" | "A_4" | "A_5" | "A_6" | "A_7" | "A_8" | "A_9" | "%future added value";
export type DeactivateDeliverableInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type DeactivateDeliverableMutationVariables = {|
  input: DeactivateDeliverableInput
|};
export type DeactivateDeliverableMutationResponse = {|
  +deactivateDeliverable: ?{|
    +updatedDeliverable: ?{|
      +state: DeliverableState
    |}
  |}
|};
export type DeactivateDeliverableMutation = {|
  variables: DeactivateDeliverableMutationVariables,
  response: DeactivateDeliverableMutationResponse,
|};
*/


/*
mutation DeactivateDeliverableMutation(
  $input: DeactivateDeliverableInput!
) {
  deactivateDeliverable(input: $input) {
    updatedDeliverable {
      state
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeactivateDeliverableInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeactivateDeliverableMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deactivateDeliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateDeliverablePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedDeliverable",
            "storageKey": null,
            "args": null,
            "concreteType": "DeliverableNode",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeactivateDeliverableMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deactivateDeliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateDeliverablePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedDeliverable",
            "storageKey": null,
            "args": null,
            "concreteType": "DeliverableNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeactivateDeliverableMutation",
    "id": null,
    "text": "mutation DeactivateDeliverableMutation(\n  $input: DeactivateDeliverableInput!\n) {\n  deactivateDeliverable(input: $input) {\n    updatedDeliverable {\n      state\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '243d1bccf404f3dc9d0fcb7c47e16399';
module.exports = node;
